import gql from 'graphql-tag';
import { UrlAliasAllData } from '../fragments';

export default gql`
query getAllUrlAlias {
    getAllUrlAlias {
        ...UrlAliasAllData
    }
}
${UrlAliasAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/getAllUrlAlias.ts